import { combineReducers } from 'redux';
import config from '../../config';
import * as TYPES from '../constants/action-types';
import music from './search-reducer';
import auth from './auth-reducer';

const initialState = {
  config,
};

const rootReducer = (state = initialState, action) => {
  let value;
  switch (action.type) {
    case TYPES.GET_CONFIG:
      value = state.config;
      break;

    default:
      value = state;
      break;
  }

  return value;
};

export default combineReducers({
  rootReducer,
  music,
  auth,
});



// WEBPACK FOOTER //
// ./src/store/reducers/index.js